<template>
	<div class="page">
		<div class="main ">
			<!-- <div class="left">
				<div class="item f-a pointer " v-for="(item, index) in category_list" 
				:class="{ active: tabs_index == index }" @click="tabsChange(index)"
				>{{ language=='cn'?item.title:item.title_en }}</div>
			</div> -->

			<keep-alive include="index">
				<router-view :index="tabs_index"></router-view>
			</keep-alive>
		</div>
	</div>
</template>

<script>
import { category_list } from '@/data/data.js';
import index from './index.vue';
export default {
	data() {
		return {
			category_list,
			tabs_index: 0,
			options: [],
			options_value: 0,
			icon: require('@/assets/image/精油水薰衣草/1.jpg')
		};
	},
	created() {
		category_list.forEach((item1, index1) => {
			this.options.push({
				text: item1.title,
				value: index1
			});
		});
	},
	computed: {
		getCategory() {
			console.log(this.category_list[this.tabs_index]);
			return this.category_list[this.tabs_index];
		},
		language() {
			return this.$store.state.language;
		}
	},
	methods: {
		tabsChange(index) {
			this.tabs_index = index;

			if (this.$route.path.indexOf('/category/detail') >= 0) {
				this.$router.replace('/category');
			}
		}
	}
};
</script>

<style lang="less" scoped>
.main {
	width: 100%;
	max-width: 100%;
	margin: 0 auto;
	font-size: 16px;
}
.header {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 99999;
	line-height: 56px;
	height: 56px;
	text-indent: 10px;
	background-color: #b3c0d1;
}
.left {
	border-right: 1px solid #eaeaea;
	// background-color: rgb(247, 251, 255);
	.item {
		width: 200px;
		height: 56px;
		text-indent: 20px;
		background-color: #fff;
	}
	.active {
		background-color: #ecf5ff;
	}
	.item:hover {
		background-color: #ecf5ff;
	}
}
</style>
